export default __webpack_public_path__ + "fonts/iconfont.b50877da147d2a344bd080b9c0b8e9ee.svg";